// extracted by mini-css-extract-plugin
export default {"loading-indicator":"Y3HGU7A7LUTxXYkeyJWw"};